import {
  WorksheetImagesAndRemarksSection,
  WorksheetResultsSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import { PageSection } from '../../../../Layout';
import ids from '../../../QestIds';
import { MeasurementsSection, ResultsSection } from '../../Sections';
import { AsDryMassesSection, AsPreparationSection } from './Sections';

const qestIds = [ids.moistureContent.AS_1289_2_1_1.rev2005];

const As1289_2_1_1_MoistureContentWorksheet: WorksheetRootComponent = () => (
  <>
    <PageSection heading="Preparation">
      <AsPreparationSection />
    </PageSection>

    <PageSection heading="Measurements">
      <MeasurementsSection />
    </PageSection>

    <PageSection>
      <WorksheetTestedBySection />
    </PageSection>

    <PageSection heading="Dry Mass">
      <AsDryMassesSection />
    </PageSection>

    <WorksheetResultsSection heading="Results">
      <ResultsSection />
    </WorksheetResultsSection>

    <PageSection heading="Images and Remarks">
      <WorksheetImagesAndRemarksSection />
    </PageSection>
  </>
);

As1289_2_1_1_MoistureContentWorksheet.qestIds = qestIds;

export default As1289_2_1_1_MoistureContentWorksheet;
export { As1289_2_1_1_MoistureContentWorksheet };
